import axios from 'axios';
import ConfigAxios from './ConfigAxios';

const URL_GET_PLAN = process.env.REACT_APP_CLAROPAGOS_URL;
const TOKEN_URL_GET_PLAN = process.env.REACT_APP_CLAROPAGOS_TOKEN;

const getAllClients = () => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/clients', options);
};

const getAllPlans = () => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/plans', options);
};

const getPlanById = dataClientId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/plans/code/' + dataClientId, options);
};

const createPlan = dataPlan => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.post(NERTHUS + '/plans', dataPlan, options);
};

const updatePlan = (dataClient, dataClientId) => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.put(NERTHUS + '/plans/' + dataClientId, dataClient, options);
};

const deletePlan = dataClientId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.delete(NERTHUS + '/plans/' + dataClientId, options);
};

const getSuscripcionPlan = dataSuscripcionId => {
  //let {NERTHUS, options} = ConfigAxios();
  let options = {
    headers: {
        'Content-Type': 'application/json',
        'Authorization': TOKEN_URL_GET_PLAN
    }
  };
  return axios.get(URL_GET_PLAN + dataSuscripcionId, options);
};

const ClientCrudService = {
  getAllClients,
  getPlanById,
  getAllPlans,
  createPlan,
  updatePlan,
  deletePlan,
  getSuscripcionPlan
};

export default ClientCrudService;